export const rendererPixelRatio = 2
export const scrollMultipleFactor = 3
